module.exports = "<p>\n  form-session-time-slots works!\n</p>\n"